export const paths = {
  HOME: '/',
  HOME_FULL: '/en/home',
  FORGOTTEN_PASSWORD: '/en/forgotten',
  SIGNUP: '/en/registration',
  LOGIN: '/en/login',
  MFA_SETUP: '/en/mfa-setup',
  MFA_RECOVERY: '/en/mfa-recovery',
  USER_VERIF_PROGRESS: '/en/verification-progress',
  TERMS_N_CONDITIONS: '/en/terms-and-conditions',
  COOKIE_POLICY: '/en/cookie-policy',
  PRIVACY_POLICY: '/en/privacy-policy',
  IMPRINT: '/en/imprint',
  USER_PROFILE: '/en/profile',
  USER_PROFILE_SETTINGS: '/en/profile/settings',
  USER_PROFILE_SETTINGS_CHANGE_PASSWORD: '/en/profile/settings/change-password',
  USER_PROFILE_SETTINGS_SECURITY: '/en/profile/settings/security',
  USER_PROFILE_SETTINGS_DEACTIVATE_ACCOUNT: '/en/profile/settings/deactivate-account',
  SEARCH_RESULTS: '/en/search-results',
  COMPANY_PROFILE: '/en/company-profile',
  CREATE_COMPANY_PROFILE: '/en/company-profile/create',
  FUNDS: '/en/funds',
  FUNDS_CREATE: '/en/funds/create',
  FUNDS_EDIT: '/en/funds/edit',
  PORTOFLIO_COMPANIES: '/en/portfolio-companies',
  PORTOFLIO_COMPANIES_CREATE: '/en/portfolio-companies/create',
  PORTOFLIO_COMPANIES_EDIT: '/en/portfolio-companies/edit',
  INVEST_PROFILES: '/en/invest-profiles',
  INVEST_PROFILES_CREATE: '/en/invest-profiles/create',
  INVEST_PROFILES_EDIT: '/en/invest-profiles/edit',
  ALL_INVESTMENTS: '/en/all-investments',
  PROJECTS: '/en/projects',
  TEAM: '/en/team',
  OUTREACH: '/en/outreach',
  ADMIN_DASHBOARD: '/en/admin-dashboard',
  PROFILER: '/en/profiler',
  PROFILER_PROJECTS: '/en/profiler-projects',
  PROFILER_TEAM: '/en/profiler-team',
  PROFILER_WATCH_LIST: '/en/profiler-watch-list',
  PROFILER_DETAILS: '/en/company-details',
  INDIVIDUAL_DETAILS: '/en/individual-details',
  AGENT: '/en/agent',
  AGENT_CONVERSATIONS: '/en/agent/conversations',
  AGENT_FAVORITES: '/en/agent/favorites',
  AGENT_ARCHIVED: '/en/agent/archived'
};

const TD_WEBSITE = 'https://transact.digital';

// Legal pages are hosted on the marketing site (td-website), which is the single
// source of truth for them (see TD-1739). The in-app static routes were removed,
// so every user-facing legal link must point at these absolute URLs and open in a
// new tab — matching the footer. Do NOT use the internal `paths.*` legal constants
// for links (they no longer resolve to a route and bounce the user to home).
export const EXTERNAL_LINKS = {
  TERMS_N_CONDITIONS: `${TD_WEBSITE}/en/terms-and-conditions`,
  PRIVACY_POLICY: `${TD_WEBSITE}/en/privacy-policy`,
  DATA_PROCESSING_AGREEMENT: `${TD_WEBSITE}/en/data-processing-agreement`,
  IMPRINT: `${TD_WEBSITE}/en/imprint`,
  COOKIE_POLICY: `${TD_WEBSITE}/en/cookie-policy`,
  // Generated by `vite build` (see vite.config.js) and served from the app's own bucket.
  THIRD_PARTY_NOTICES: '/third-party-notices.txt'
};

export const routes = {
  USER_PROFILE_PATH: '/en/profile/:section?/:subsection?',
  FUNDS_PATH: '/en/funds/:component?',
  PORTFOLIO_COMPANIES_PATH: '/en/portfolio-companies/:component?',
  INVEST_PROFILES_PATH: '/en/invest-profiles/:component?',
  PROFILER_DETAILS_PATH: '/en/company-details/:companyId',
  INDIVIDUAL_DETAILS_PATH: '/en/individual-details/:individualId',
  AGENT_CHAT_PATH: '/en/agent/chat/:chatId'
};
